import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from "../../environments/environment";
import { User } from "../model/user.model";
import { MST_PRODUCT, ProductSearch } from "../model/product.model";


const API_URL = environment.apiUrl;
const httpOptions = {
    headers: new HttpHeaders(
        {
            'Content-Type': 'application/json',
        }
    )
};

@Injectable()
export class ProductService {
    private Url = '';  // URL to web api
    currentUser: User;

    constructor(
        private http: HttpClient) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.Url = API_URL + '/' + (this.currentUser.CompanyID ? this.currentUser.CompanyID.toString() : "1") + '/product';
    }


    SaveProduct(data: MST_PRODUCT): Observable<any> {
        return this.http.post<any>(this.Url + "", data, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }


    GetProductList(search: ProductSearch): Observable<MST_PRODUCT[]> {
        return this.http.post<MST_PRODUCT[]>(this.Url + "/GetProductList", search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    getProductById(ProductId: number): Observable<MST_PRODUCT> {
        return this.http.get<MST_PRODUCT>(this.Url + "/" + ProductId.toString(), httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    delProductById(ProductId: number): Observable<any> {
        return this.http.post<any>(this.Url + "/delproduct/" + ProductId.toString(), httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetProductForExport(search: ProductSearch, type: number): Observable<any> {

        return this.http.post(this.Url + '/GetProductForExport/' + type, search, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',

            }),
            responseType: 'arraybuffer'
        }).pipe(tap((x) => {
        }),
            catchError(this.handleError<ProductSearch>('GetProductForExport'))
        );
    }


    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

    /** Log a ScgCompanyService message with the MessageService */
    private log(message: string) {
        console.log(message);
        // this.messageService.add('ScgCompanyService: ' + message);
    }

}


// WEBPACK FOOTER //
// ./src/app/services/product.service.ts